'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMargin = undefined;

var _Length = require('../Length');

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SIDES = ['top', 'right', 'bottom', 'left'];

var parseMargin = exports.parseMargin = function parseMargin(style) {
  return SIDES.map(function (side) {
    return new _Length2.default(style.getPropertyValue('margin-' + side));
  });
};